//
//
//
//
//
//
//
//
//
//
//
//
import { sendSock, initWebSocket, websocketclose } from '@/util/socket.js';
export default {
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    //   this.getsocket()
    console.log(123456);
  },
  methods: {
    getsocket: function getsocket() {
      initWebSocket("ws://192.168.1.103:5010/ws", 0);
      sendSock('', 0, function (res) {
        console.log(res);
      });
    }
  }
};